module.exports = __webpack_public_path__ + "img/Shawarma Meal-Falafel.0c15cd21.jpg";